





































import Vue from 'vue'
import iNoBounce from 'inobounce'

import Preload from '../utils/Preload'
import {ShapeGroup, Shape} from '../interface'
import types from '../store/types'

import BaseButton from '../components/Base/Button.vue'
import shapes from '../shape'

export default Vue.extend({
  name: 'home',

  components: {
    BaseButton
  },

  beforeCreate() {
    window.scrollTo(0, 0)
    iNoBounce.disable()
  },

  mounted() {
    // If Shape group is empty -> If initial boot
    if (! this.$store.state.Shape.group.length) {
      this.$store.commit(types.mutations.APP_LOADING_TEXT, '必要なデータを読み込んでいます')
      this.$store.commit(types.mutations.APP_LOADING, true)

      const shapeList: Shape[] = []
      const shapeGroup: ShapeGroup[] = []

      // Preload mask images
      const loadImages: string[] = []
      const loadLineImages: string[] = []
      const indexes: Array<{groupIndex: number, elemIndex: number}> = []
      shapes.forEach((shapeGroup, groupIndex) => {
        shapeGroup.group.forEach((elem, elemIndex) => {
          loadImages.push(elem.image)
          loadLineImages.push(elem.line)
          indexes.push({groupIndex, elemIndex})
        })
      })

      Preload.preloadImages(loadImages)
        .then((data) => {
          data.forEach((image, key) => {
            if (image.state === 'fulfilled') {
              if (! image.value) {
                return
              }

              const groupIndex: number = indexes[key].groupIndex
              const elemIndex: number = indexes[key].elemIndex

              if (! shapeGroup[groupIndex]) {
                shapeGroup[groupIndex] = {
                  label: shapes[groupIndex].label,
                  list: []
                }
              }
              shapeGroup[groupIndex].list.push({
                index: key,
                label: shapes[groupIndex].group[elemIndex].label
              })

              shapeList.push({
                index: key,
                group: shapes[groupIndex].label,
                label: shapes[groupIndex].group[elemIndex].label,
                compress: shapes[groupIndex].group[elemIndex].compress,
                image: shapes[groupIndex].group[elemIndex].image,
                line: shapes[groupIndex].group[elemIndex].line,
                trimmark: shapes[groupIndex].group[elemIndex].trimmark,
                comp: shapes[groupIndex].group[elemIndex].comp,
                width: image.value.width,
                height: image.value.height,
                quantityLimit: shapes[groupIndex].group[elemIndex].quantityLimit
              })
            }
          })

          Preload.preloadImages(loadLineImages)
            .then(() => {
              this.$store.commit(types.mutations.APP_LOADING, false)
              this.$store.commit(types.mutations.SHAPE_LIST, shapeList)
              this.$store.commit(types.mutations.SHAPE_GROUP, shapeGroup)
            })
        })
    }
  },

  methods: {
    linkToMaterialPage() {
      this.$router.push('material')
    }
  }
})
